import Image from 'next/image'
import logo from 'ui/images/svg/rt-logo.png'
import { getBaseUrl } from 'utils'

export default function CheckoutFooter() {
	return (
		<div className="my-10 border-t pt-10 flex flex-wrap justify-between items-center gap-6">
			<div className="flex items-center space-x-8">
				<Image src={logo} alt="Real Thread Logo" quality={70} sizes="100px" className="w-10 h-10" />
				<div className="flex flex-col">
					<span className="font-medium">Need Help?</span>
					<span>
						Call us at <a href="tel:4076793895">(407) 679-3895</a>
					</span>
				</div>
			</div>
			<span className="text-xs">
				{new Date().getFullYear()} © Real Thread, Inc. |{' '}
				<a className="hyperlink" href={`${getBaseUrl()}/policies`}>
					Policies
				</a>
			</span>
		</div>
	)
}
